import { Component, Input } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import { DonationStatusTypeEnum } from 'src/app/shared/enum/donation-status.enum';
import { PaymentMethodEnum } from 'src/app/shared/enum/payment-method.enum';
import { PledgingStatusTypeEnum } from 'src/app/shared/enum/pledging-status.enum';
import { ConfirmDonationMailModel } from 'src/app/shared/model/confirm-donation-mail.model';
import { DonationStatusModel } from 'src/app/shared/model/donation-status.model';
import { DonationConfirmModel } from 'src/app/shared/model/donationConfirm.model';
import { PledgePaymentModel } from 'src/app/shared/model/pledge-donation.model';
import { ReceiptModel } from 'src/app/shared/model/receipt.model';
import { DonationService } from 'src/app/shared/services/donation/donation.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { TagCsrService } from 'src/app/shared/services/tag-csr/tag-csr.service';

@Component({
  selector: 'app-csr-internal-donations',
  templateUrl: './csr-internal-donations.component.html',
  styleUrl: './csr-internal-donations.component.scss',
})
export class CsrInternalDonationsComponent {
  @Input() from: string = null;

  public statusOptions: DonationStatusTypeEnum[] = [
    DonationStatusTypeEnum.DONATED,
    DonationStatusTypeEnum.FAILED,
    DonationStatusTypeEnum.REFUNDED,
  ];
  public statusOptionsPledged: PledgingStatusTypeEnum[] = [
    PledgingStatusTypeEnum.PAYMENT_PROCESSING,
    PledgingStatusTypeEnum.FAILED,
    PledgingStatusTypeEnum.REFUNDED,
  ];
  private donationConfirmModel: DonationConfirmModel =
    new DonationConfirmModel();
  private isResetting: boolean = false;

  public statusModel: DonationStatusModel = new DonationStatusModel();
  public showReceiptPopUp: boolean = false;

  public whatsappFilter: boolean = false;

  public companyList: any[] = [];
  public selectedCompany: string = null;
  public selectedNgoType: string = null;
  public donationList: any = [];
  public created_at: Date = null;
  public endDate: Date;
  public startDate: Date;
  public ngoSelected: boolean = false;

  public recentActivity = [];
  public donationHistory = [];
  public donatedDonations = [];
  public pledgingDonations = [];

  public selectedDonationType: string = 'All';
  public selectedStatus = 'ALL';

  public customPledgePopup: boolean = false;
  public pledgePaymentModel: PledgePaymentModel = new PledgePaymentModel();
  public event: any;
  public donation: any;

  public receipt: ReceiptModel = new ReceiptModel();
  public receiptFile: any;

  public confirmDonationMailModel: ConfirmDonationMailModel =
    new ConfirmDonationMailModel();

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly donationService: DonationService,
    private readonly sharedService: CommonSharedServiceService,
    private readonly localStorageService: LocalStorageService,
    private readonly tagCsrService: TagCsrService
  ) {
    this.sharedService.updateReceiptPopupState(false);
  }

  ngOnInit(): void {
    this.sharedService.updateReceiptPopupState(false);
    this.getAllCompany();
  }

  public getAllCompany(): void {
    this.tagCsrService.getAllCompany().subscribe({
      next: (result) => {
        this.companyList = result;
      },
    });
  }

  public dateChanged(e: any): void {
    this.startDate = e.value[0];
    this.endDate = e.value[1];

    if (this.selectedCompany) {
      this.getAllDonorCrmActivity();
    }
  }

  public onValueChanged(e: any): void {
      this.selectedCompany = e.value;
      const { isValid } = ValidationEngine.validateGroup('validationGrp');
      if (isValid) {
        this.getAllDonorCrmActivity();
      }
  }

  public onDonationTypeChanged(e: any) {
    this.selectedDonationType = e.value;
    this.filterRecentActivity();
  }

  public onStatusChanged(e: any) {
    this.selectedStatus = e.value;
    this.filterRecentActivity();
  }

  public getAllDonorCrmActivity(
    startCallDate?: Date,
    endDCallDate?: Date
  ): void {
    this.tagCsrService
      .getTaggedExternalCsrDonation(
        this.startDate,
        this.endDate,
        this.selectedCompany
      )
      .subscribe({
        next: (result: any) => {
          this.donatedDonations = result.donated_donations;
          this.pledgingDonations = result.pledging_donations;

          this.ngoSelected = true;
          this.filterRecentActivity();
        },
      });
  }

  public filterRecentActivity(): void {
    const isAll = this.selectedStatus === 'ALL';
    const isDonated = this.selectedStatus === 'DONATED';
    const isPledged = this.selectedStatus === 'PLEDGED';

    if (isAll) {
      this.donationHistory = [
        ...this.donatedDonations,
        ...this.pledgingDonations,
      ];
    } else if (isPledged) {
      this.donationHistory = [...this.pledgingDonations];
    } else if (isDonated) {
      this.donationHistory = [...this.donatedDonations];
    }

    this.donationHistory = this.donationHistory.filter((entry) => {
      let flag = true;
      if (this.whatsappFilter) {
        flag = entry?.is_video_call_active;
      }
      if (this.selectedDonationType === 'Direct NGO') {
        flag = flag && entry?.is_direct_donation;
      } else if (this.selectedDonationType === 'Campaign') {
        flag = flag && entry?.is_direct_donation != true;
      }

      return flag;
    });

    this.donationHistory = this.donationHistory.map((donation: any) => ({
      ...donation,
      amount: donation?.pledged_amount ?? donation?.amount,
      status: donation?.pledging_status ?? donation?.status,
    }));

    this.donationHistory = this.donationHistory.sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );

    this.recentActivity = [...this.donationHistory];
  }

  public filterList() {
    if (this.whatsappFilter) {
      this.recentActivity = this.recentActivity.filter(
        (list) => list?.is_video_call_active === true
      );
    } else {
      this.recentActivity = [...this.donationHistory];
    }
  }

  private statusUpdate(id: string) {
    this.tagCsrService
      .updateStatusDonation(id, this.pledgePaymentModel)
      .subscribe({
        next: (res) => {
          this.pledgePaymentModel = new PledgePaymentModel();
          this.utilitiesService.showSwal(
            'success',
            'Donation Status Changed successfully!'
          );
        },
        error: (err) => {
          this.utilitiesService.showSwal(
            'error',
            'Error changing the Donation status'
          );
        },
      });
  }

  private statusUpdateDonation(id: string) {
    this.tagCsrService
      .updateStatusDonation(id, this.donationConfirmModel)
      .subscribe({
        next: (res) => {
          this.utilitiesService.showSwal(
            'success',
            'Donation Status Changed successfully.'
          );
          this.isResetting = false;
        },
        error: (err) => {
          this.utilitiesService.showSwal(
            'error',
            'Error changing the Donation status'
          );
        },
      });
  }

  private sendConfirmationMail(donation: any) {
    this.confirmDonationMailModel.campaign =
      donation.campaign_title ?? donation?.ngo_name;
    this.confirmDonationMailModel.amount = this.donation.amount;
    this.confirmDonationMailModel.to = donation.email;
    this.confirmDonationMailModel.subject = 'Donation Confirmation';
    this.donationService
      .sendConfirmDonationMail(this.confirmDonationMailModel)
      .subscribe({
        next: (res) => {
          this.utilitiesService.showSwal(
            'success',
            'Successfully send the Mail'
          );
          validationEngine.resetGroup('pledgeValidationGrp');
        },

        error: (err) => {
          this.utilitiesService.showSwal('error', 'Failed to send Mail');
        },
      });
  }

  private async confirmAction(
    message: string,
    confirmButtonText: string,
    status: boolean
  ) {
    if (status) {
      return await this.utilitiesService.showSwalAndReturn({
        type: 'warning',
        title: 'Are you sure?',
        message: message,
        confirmButtonText: confirmButtonText,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      });
    } else {
      return null;
    }
  }

  public statusChanged(event: any, donation: any): void {
    this.event = event;
    this.donation = donation;

    this.statusModel.pledging_status = event?.value;

    if (this.statusModel.pledging_status === donation.status) {
      this.utilitiesService.showSwal(
        'warning',
        `Donation status is already ${event?.value}`
      );
      event.component?.option?.('value', null);
      return;
    } else if (this.statusModel.pledging_status) {
      this.isResetting = false;
    }

    if (event?.value === 'DONATED') {
      this.pledgePaymentModel = new PledgePaymentModel(donation);
      this.pledgePaymentModel.pledging_status = event?.value;
      this.pledgePaymentModel.received_amount = donation?.amount;
      this.customPledgePopup = true;
    } else {
      this.pledgePaymentModel.pledging_status = event?.value;
      this.updateStatus(event, donation);
    }
  }

  private async updateStatus(event: any, donation: any) {
    if (this.isResetting) {
      this.isResetting = false;
      return;
    }

    const newStatus = event.value;

    const confirmed = await this.confirmAction(
      `Change status to ${newStatus}?`,
      'Confirm',
      Boolean(newStatus)
    );

    if (!confirmed?.isConfirmed) {
      return this.resetStatus(event);
    }

    try {
      if (newStatus === DonationStatusTypeEnum.DONATED) {
        await this.processDonation(donation);
      } else {
        await this.statusUpdate(donation.id);
      }

      donation.status = newStatus;
    } catch (error) {
      console.error('Error updating status:', error);
    }
  }

  public resetStatus(event: any): void {
    this.isResetting = true;
    event.component?.option?.('value', null);
  }

  private async processDonation(donation: any): Promise<void> {
    const sessionUser = this.localStorageService.getSessionUser();

    this.donationConfirmModel.update({
      admin_id: sessionUser?.id,
      payment_method: donation.payment_method || PaymentMethodEnum.Bkash,
      payment_receipt: donation?.payment_receipt || 'N/A',
      received_amount: Number(donation?.amount) || 0,
      pledging_status: this.statusModel.pledging_status,
      transaction_id: donation?.transaction_id || 'N/A',
    });

    await this.statusUpdateDonation(donation.id);
  }

  public customizePledgeAmount(): void {
    const { isValid } = ValidationEngine.validateGroup('pledgeValidationGrp');
    if (isValid) {
      this.tagCsrService
        .updateStatusDonation(this.donation?.id, this.pledgePaymentModel)
        .subscribe({
          next: (result) => {
            this.donation.status = this.event.value;
            this.donation.amount = this.pledgePaymentModel?.received_amount;
            this.donation.payment_method =
              this.pledgePaymentModel?.payment_method;
            this.donation.transaction_id =
              this.pledgePaymentModel?.transaction_id;

            this.event.component?.option?.('value', null);
            this.customPledgePopup = false;
            this.sendConfirmationMail(this.donation);
          },
          error: (err) => {
            console.log(err);
          },
        });
    }
  }

  public openDetailsPopup(receipt: any) {
    this.receipt = {
      invoice_no: 'N/A',
      invoice_to: receipt?.name,
      invoice_date: new Date(),
      label2Name: 'NGO',
      label2Value: receipt?.ngo_name,
      payment_method: 'Card',
      paid_to: '',
      firstColumnName: 'Campaign',
      firstColumnValue: receipt?.campaign_title,
      secondColumnName: 'Transaction ID',
      secondColumnValue: receipt?.transaction_id || 'N/A',
      thirdColumnName: 'Donated Amount',
      thirdColumnValue: receipt?.amount,
      total_amount: String(receipt?.amount),
    };
    this.receiptFile = this.utilitiesService.jsonParse(
      receipt?.payment_receipt
    );
    this.sharedService.updateReceiptPopupState(true);
  }

  public preventMinusSign(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'Minus') {
      event.preventDefault(); // Block the minus sign
    }
  }

  public cancelCustomPledgePopup() {
    validationEngine.resetGroup('pledgeValidationGrp');
    this.customPledgePopup = false;
  }
}
